/**
 * StatCard - Big number display with label, unit, and optional icon.
 *
 * @param {{ value: string|number, label: string, unit?: string, icon?: React.ReactNode, size?: 'sm'|'md'|'lg', color?: string }} props
 */
export default function StatCard({ value, label, unit, icon, size = 'md', color = 'text-white' }) {
  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-6xl',
  };

  const paddingClasses = {
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
  };

  return (
    <div className={`bg-zinc-900 rounded-2xl ${paddingClasses[size]} flex flex-col items-center justify-center min-h-[80px]`}>
      {icon && <div className="text-zinc-400 mb-1">{icon}</div>}
      <div className="flex items-baseline gap-1">
        <span className={`${sizeClasses[size]} font-bold ${color} tabular-nums leading-none`}>
          {value ?? '--'}
        </span>
        {unit && (
          <span className="text-zinc-400 text-sm font-medium">{unit}</span>
        )}
      </div>
      <span className="text-zinc-400 text-xs font-medium mt-1 uppercase tracking-wider">
        {label}
      </span>
    </div>
  );
}
